import { createStore } from 'vuex'

export default function () {
  const Store = createStore({
    modules: {},

    strict: false
  })

  return Store
}
